import Link from 'next/link';
import styled from 'styled-components';
import { LinkVariants, LinkSizes } from './';

export const LinkComponent = styled(Link)<{ variant?: LinkVariants; size?: LinkSizes }>`
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  background-color: transparent;
  white-space: nowrap;
  cursor: pointer;
  :active {
    opacity: 0.8;
  }
  ${({
    variant,
    size,
    theme: {
      borderRadius: { full },
      colors: {
        gradients: { primary },
        primary: { main, dark },
        functional: { darkestGray, white },
      },
      breakPoints: { lg },
    },
  }) => {
    switch (variant) {
      case 'button':
        return `
        align-items: center;
        justify-content: center;
        border-radius: ${full};
        padding: 0 3.2rem;
        ${size === 'lg' ? 'height: 53px;' : 'height: 45px;'}
        background-color: ${main};
        color: ${white};
        transition: background-size 1s;
        :hover{
            background: ${primary};
            background-position: 0 0;
            animation: gradientX 0.5s ease-in-out;
          }
          @media (max-width: ${lg}) {
            height: 43px;
            line-height: 43px;
          }
        `;

      case 'thick':
        return `
        height: auto;
        color: ${main};
        border-bottom: 2px solid ${main};
        position: relative;
        :hover{
          color: ${dark};
          border-color: ${dark};
        }
      `;

      case 'outline':
        return `
          box-sizing: border-box;
          color: ${main};
          border: 2px solid ${main};
          border-radius: ${full};
          align-items: center;
          justify-content: center;
          padding: 0 3.2rem;
          ${size === 'lg' ? 'height: 53px;' : 'height: 45px;'}
          svg, img {
            fill: ${main};
            width: 2.4rem;
            height: 2.4.rem;
            margin-left: 1rem;
          }
          @media (max-width: ${lg}) {
            height: 43px;
            line-height: 43px;
          }
          :hover{
            color: ${dark};
            border-color: ${dark};
          }
        `;

      default:
        return `
          color: ${darkestGray};
          :hover{
            color: ${main};
          }
        `;
    }
  }}
`;
